export const screens = {
  md: 768,
  lg: 1024,
}
